(($, Drupal, once) => {
  Drupal.behaviors.mobileSplashMenu = {
    attach(context) {
      if ($(window).width() < 768) {
        $(once('splash-page', 'body')).each(() => {
          const divTA = context.querySelector('.target-audience');
          const divTAlink = divTA.querySelector('.menu-item--active-trail');
          if(divTAlink){
            divTAlink.addEventListener('click', e => {
              e.preventDefault();
              divTA.classList.toggle('mobile-open');
              context.querySelector('.splash-page').classList.toggle('open');

              if (context.querySelector('.splash-page').classList.contains('open')) {
                context.querySelector('.layout-container').scrollIntoView();
                context.querySelector('.layout-container').classList.add('open-mobile-menu');
              }
              else {
                setTimeout(() => {
                  context.querySelector('.layout-container').classList.remove('open-mobile-menu');
                }, 1000);
              }
            });
          }
      });
      }
    },
  };
}) (jQuery, Drupal, once);
